import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Text } from 'shared/components'
import { InWinImage } from 'routes/shared/components'

import * as styles from './styles'

const TeamCellComponent = ({ value: team }) => {
  return (
    <div css={styles.container}>
      <Margin right={1}>
        {team?.logo ? (
          <InWinImage
            source={team?.logo}
            alt={team?.teamName}
            css={styles.logo}
          />
        ) : (
          <div css={styles.imagePlaceholder} />
        )}
      </Margin>
      <div css={styles.textContainer}>
        <Text size={16} medium>
          {team?.teamName}
        </Text>
      </div>
    </div>
  )
}

TeamCellComponent.propTypes = {
  value: PropTypes.shape(),
}

export { TeamCellComponent }
